import { CustomMenuItem } from '../../commons/components/GrowegyMenu';
import { GetItOnGooglePlayBanner } from './GetItOnGooglePlayBanner';

export const createPlayStoreMenuItem = (
  isHidden: boolean,
  onClick: () => void,
  dataTest?: string
): CustomMenuItem => ({
  type: 'custom',
  isHidden,
  dataTest,
  component: () => <GetItOnGooglePlayBanner onClick={onClick} />,
});
